import { AdminRole } from "@repo/api-dtos"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import * as React from "react"
import { PageHeader } from "@/components/layout"
import { Skeleton } from "@/components/ui/skeleton"
import { useAdminRolesContext } from "@/contexts/admin-roles-context"
import { CarouselRankingConfigEditor } from "@/features/carousel-ranking-config/CarouselRankingConfigEditor"
import { useCarouselRankingConfig } from "@/queries/marketplace"

export const Route = createFileRoute("/configuration/carousels")({
	component: CarouselRankingConfigurationPage,
})

function CarouselRankingConfigurationPage() {
	const navigate = useNavigate()
	const { hasAnyRole, hasRole } = useAdminRolesContext()
	const canRead = hasAnyRole([
		AdminRole.Superadmin,
		AdminRole.MarketplaceOrderSupport,
	])
	const canEdit = hasRole(AdminRole.Superadmin)
	const { configVersion, isLoading, error, refetch } = useCarouselRankingConfig(
		{ enabled: canRead },
	)

	React.useEffect(() => {
		if (!canRead) navigate({ to: "/unauthorized" })
	}, [canRead, navigate])
	if (!canRead) return null

	const header = (
		<PageHeader
			title="Carousel ranking"
			description="How the home page, Explore and seller shop carousels pick and order listings. Each save is a new version, used within a minute."
		/>
	)

	if (error || isLoading || !configVersion) {
		return (
			<div className="flex max-w-6xl flex-col gap-6 p-6">
				{header}
				{error ? (
					<p className="rounded-lg bg-bad-soft px-3 py-2 text-bad">
						Failed to load the configuration: {error.message}
					</p>
				) : (
					<div className="flex flex-col gap-3">
						<Skeleton className="h-[58px] w-full" />
						<Skeleton className="h-[58px] w-full" />
						<Skeleton className="h-[58px] w-full" />
						<Skeleton className="h-[58px] w-full" />
					</div>
				)}
			</div>
		)
	}

	return (
		<CarouselRankingConfigEditor
			header={header}
			active={configVersion}
			canEdit={canEdit}
			onReload={() => refetch()}
		/>
	)
}
